import React from "react";
import { ArrowUp, ArrowDown, ArrowLeft, ArrowRight } from "lucide-react";
import { useI18n } from "../i18n/I18nContext";
import Gx4000Pad from "./Gx4000Pad";

const DPadIcons = () => (
  <span className="inline-flex items-center gap-2 text-[#00ffff]" aria-label="D-Pad">
    <ArrowUp size={22} strokeWidth={2.5} />
    <ArrowDown size={22} strokeWidth={2.5} />
    <ArrowLeft size={22} strokeWidth={2.5} />
    <ArrowRight size={22} strokeWidth={2.5} />
  </span>
);

export const ControlsSection = () => {
  const { t } = useI18n();
  return (
    <section
      id="controls"
      data-testid="controls-section"
      className="relative max-w-7xl mx-auto px-4 sm:px-6 py-20 md:py-28"
    >
      <div className="grid lg:grid-cols-12 gap-10 items-start">
        <div className="lg:col-span-5">
          <div className="section-tag">{t.controls.title}</div>
          <h2 className="font-pixel text-[#00ffff] glow-cyan text-4xl sm:text-6xl mt-2 tracking-widest">
            {t.controls.title}
          </h2>
          <p className="font-mono text-sm text-[#94a3b8] mt-5 leading-relaxed">
            {t.controls.bombNote}
          </p>

          {/* GX4000 pad stylized */}
          <div className="mt-8 relative">
            <div className="absolute inset-0 rounded-2xl blur-2xl opacity-50 pointer-events-none" style={{
              background: "radial-gradient(closest-side, rgba(0,255,255,0.25), transparent 70%)",
            }} />
            <Gx4000Pad className="relative w-full max-w-md drop-shadow-[0_8px_24px_rgba(0,0,0,0.6)]" />
            <div className="mt-3 font-pixel text-[#94a3b8] text-base tracking-widest text-center">
              ▮ AMSTRAD GX4000 PAD — 2 BUTTONS + PAUSE
            </div>
          </div>
        </div>

        <div className="lg:col-span-7">
          <div className="terminal-frame">
            <table className="w-full font-mono text-sm">
              <thead>
                <tr className="text-left">
                  <th className="px-5 py-3 font-pixel text-[#94a3b8] text-base tracking-widest border-b border-[#00ffff]/20">INPUT</th>
                  <th className="px-5 py-3 font-pixel text-[#94a3b8] text-base tracking-widest border-b border-[#00ffff]/20">ACTION</th>
                </tr>
              </thead>
              <tbody>
                {t.controls.table.map((row, i) => (
                  <tr key={i} className="border-b border-white/5 last:border-0">
                    <td className="px-5 py-4 text-[#00ffff] glow-cyan font-pixel text-xl">
                      {i === 0 ? <DPadIcons /> : row.btn}
                    </td>
                    <td className="px-5 py-4 text-[#e2e8f0]/90">{row.action}</td>
                  </tr>
                ))}
              </tbody>
            </table>
          </div>
        </div>
      </div>
    </section>
  );
};

export default ControlsSection;
